import useChangeContentDecision from "./useChangeContentDecision";
import AssetCover from "common/features/asset/AssetCover";
import { useIntl } from "react-intl";
import ConfirmOptOutDialog from "./ConfirmOptOutDialog";
import MaterialMetaData from "./MaterialMetaData";
import styles from "./ConfirmOptOutItemDialog.module.scss";
import { getDaysRemaining } from "./timeHelper";
import useFindCourse from "./useFindCourse";
import { CourseMaterial } from "./coursesLoader";
import useMaterialOptDeadline from "./useMaterialOptDeadline";

interface ConfirmOptOutItemDialog {
  courseMaterial: CourseMaterial;
  setOpenConfirmOptOutDialog: () => void;
  selectProgram?: () => void;
}

export default function ConfirmOptOutItemDialog({
  courseMaterial,
  setOpenConfirmOptOutDialog,
  selectProgram,
}: ConfirmOptOutItemDialog) {
  const intl = useIntl();
  const { title, vbid, courseId } = courseMaterial;
  const course = useFindCourse({ courseId });
  const { optDeadline } = useMaterialOptDeadline(courseMaterial);
  const { contentOptOut, isOptDecisionProcessing } = useChangeContentDecision({
    courseMaterial,
    afterDecisionChange: setOpenConfirmOptOutDialog,
    selectProgram,
  });
  const getSubtitle = () => {
    return optDeadline
      ? intl.formatMessage(
          {
            defaultMessage:
              "{count, plural, =0 {Today is the last day to change your decision.} =1 {You have 1 day to change your decision.} other {You have # days to change your decision.}}",
          },
          {
            count: getDaysRemaining(optDeadline),
          }
        )
      : "";
  };
  return (
    <ConfirmOptOutDialog
      title={intl.formatMessage(
        { defaultMessage: "Opting out of {title}" },
        { title }
      )}
      subtitle={getSubtitle()}
      onRequestClose={() => setOpenConfirmOptOutDialog()}
      onConfirmOptOut={() => void contentOptOut()}
      isProcessing={isOptDecisionProcessing}
    >
      <h2 className={styles.courseTitle}>{course?.title}</h2>
      <div className={styles.coverRow}>
        <div className={styles.cover}>
          <AssetCover vbid={vbid} width={120} width2x={240} />
        </div>
        <div className={styles.metaData}>
          <MaterialMetaData courseMaterial={courseMaterial} titleTag="h3" />
        </div>
      </div>
    </ConfirmOptOutDialog>
  );
}
